import { useLayoutEffect, useState } from 'react';

export default function useGutterFloor(enabled, layoutRef) {
  const [footerHeight, setFooterHeight] = useState(0);

  useLayoutEffect(() => {
    const layout = layoutRef.current;
    if (!enabled || !layout) {
      return;
    }

    let footers = new Set();
    const measure = () => {
      setFooterHeight(Math.max(0, ...Array.from(footers, (footer) => footer.getBoundingClientRect().height)));
    };
    const resizeObserver = new ResizeObserver(measure);
    const syncFooters = () => {
      const nextFooters = new Set(layout.querySelectorAll('[data-gutter-footer]'));
      for (const footer of footers) {
        if (!nextFooters.has(footer)) {
          resizeObserver.unobserve(footer);
        }
      }
      for (const footer of nextFooters) {
        if (!footers.has(footer)) {
          resizeObserver.observe(footer);
        }
      }
      footers = nextFooters;
      measure();
    };

    // Footers can mount after a query resolves, then grow when warnings appear.
    const mutationObserver = new MutationObserver(syncFooters);
    mutationObserver.observe(layout, { childList: true, subtree: true });
    syncFooters();
    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, [enabled, layoutRef]);

  return enabled ? footerHeight : 0;
}
